import React from 'react';
import { Phone, Calendar, MessageCircle } from 'lucide-react';
export function MobileBottomBar() {
  return <div className="md:hidden fixed bottom-0 left-0 right-0 bg-blue-deep text-white z-40 pb-safe shadow-[0_-8px_24px_rgba(26,39,64,0.15)] border-t border-white/10" data-id="element-276">
      <div className="flex items-center justify-between px-2 py-3" data-id="element-277">
        <a href="tel:0387143350" className="flex flex-col items-center justify-center flex-1 gap-1 border-r border-white/10 hover:bg-white/5 transition-colors rounded-l-lg py-1" data-id="element-278">
          <Phone size={22} className="text-teal" data-id="element-279" />
          <span className="text-[11px] font-bold tracking-wide mt-1" data-id="element-280">CALL</span>
        </a>
        <a href="#tours" className="flex flex-col items-center justify-center flex-1 gap-1 border-r border-white/10 hover:bg-white/5 transition-colors py-1 relative" data-id="element-281">
          <div className="absolute -top-6 bg-coral text-white w-12 h-12 rounded-full flex items-center justify-center shadow-lg border-4 border-blue-deep" data-id="element-282">
            <Calendar size={20} data-id="element-283" />
          </div>
          <span className="text-[11px] font-bold tracking-wide mt-6" data-id="element-284">TOUR</span>
        </a>
        <a href="https://wa.me/61387143350" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center justify-center flex-1 gap-1 hover:bg-white/5 transition-colors rounded-r-lg py-1" data-id="element-285">
          <MessageCircle size={22} className="text-yellow" data-id="element-286" />
          <span className="text-[11px] font-bold tracking-wide mt-1" data-id="element-287">
            WHATSAPP
          </span>
        </a>
      </div>
    </div>;
}